import * as R from 'ramda';
// helpers/constants
import * as G from '../../../../helpers';
import * as GC from '../../../../constants';
// icons
import { truck, driver, trailer } from '../../../../svgs';
//////////////////////////////////////////////////

const fleetIcon = {
  trucks: truck,
  drivers: driver,
  trailers: trailer,
};

export const getFleetIcon = (fleetType) => (
  fleetIcon[fleetType](G.getTheme('colors.dark.blue'))
);

export const joinTrailers = (trailers) => (
  R.join(', ', R.map((trailer) => R.pathOr('unavailable', ['unitId'], trailer), trailers))
);

export const takeArrayByOddOrEven = (array, odd) => (
  array.filter((_, index) => R.equals(R.modulo(R.add(index, 1), 2), G.ifElse(odd, 1, 0)))
);

export const filterTrailers = (trailers, drivers) => {
  const usedTrailers = R.compose(
    R.reduce((prev, guids) => R.concat(prev, guids), []),
    R.filter((trailerGuids) => G.isNotNilAndNotEmpty(trailerGuids)),
    R.map((driver) => R.path(['fleetObj', 'assignment', 'trailerGuids'], driver)),
  )(drivers);
  return trailers.filter((trailer) => G.notContain(trailer.fleetObj.guid, usedTrailers));
};

export const filterTrucks = (trucks, drivers) => {
  const usedTrucks = R.compose(
    R.filter((truckGuid) => G.isNotNil(truckGuid)),
    R.map((driver) => R.path(['fleetObj', 'assignment', 'truckGuid'], driver)),
  )(drivers);
  return trucks.filter((truck) => G.notContain(truck.fleetObj.guid, usedTrucks));
};

export const makeAssignmentInfo = (initialFleets, fleet) => {
  const assignment = {};
  const teamDriverGuid = R.path(['assignment', GC.FIELD_SECONDARY_DRIVER_GUID], fleet);
  const truckGuid = R.path(['assignment', GC.FIELD_TRUCK_GUID], fleet);
  const trailerGuids = R.path(['assignment', GC.FIELD_TRAILER_GUIDS], fleet);
  if (G.isNotNilAndNotEmpty(teamDriverGuid)) {
    const indexedDrivers = R.indexBy(R.prop(GC.FIELD_GUID), initialFleets.drivers);
    assignment.teamDriver = indexedDrivers[teamDriverGuid];
  }
  if (G.isNotNilAndNotEmpty(truckGuid)) {
    const indexedTrucks = R.indexBy(R.prop(GC.FIELD_GUID), initialFleets.trucks);
    assignment.truck = indexedTrucks[truckGuid];
  }
  if (G.isNotNilAndNotEmpty(trailerGuids)) {
    const indexedTrucks = R.indexBy(R.prop(GC.FIELD_GUID), initialFleets.trailers);
    assignment.trailers = trailerGuids.map((guid) => indexedTrucks[guid]);
  }
  return assignment;
};

export const sortEvents = (events, loadIndexName) => (
  R.compose(
    R.sortBy(R.prop(loadIndexName)),
    R.values(),
    R.filter((event) => G.isNotNil(event)),
  )(events)
);

export const getTelMappedEventsForMap = (stops) => {
  const mappedStops = R.map((stop) => {
    const lat = R.path([GC.SYSTEM_OBJECT_LOCATION, GC.FIELD_LATITUDE], stop);
    const lng = R.path([GC.SYSTEM_OBJECT_LOCATION, GC.FIELD_LONGITUDE], stop);
    if (R.or(R.isNil(lat), R.isNil(lng))) return null;
    return {
      ...stop,
      title: `${G.toTitleCase(stop.eventType)} ${stop[GC.FIELD_TEL_EVENT_INDEX]}`,
      latLng: { lat, lng },
    };
  }, stops);
  return sortEvents(mappedStops, GC.FIELD_TEL_EVENT_INDEX);
};

const getFleetsCount = (fleets) => R.length(R.filter((fleet) => R.or(
  G.isNotNilAndNotEmpty(R.prop('precedingLocation', fleet)),
  G.isNotNilAndNotEmpty(R.prop('currentLocation', fleet)),
), fleets));

const getFleetsLength = (props) => R.sum([
  getFleetsCount(props.drivers),
  getFleetsCount(props.trucks),
  getFleetsCount(props.trailers),
]);

export const getMultiswitchOptions = (props) => [
  {
    width: 50,
    value: 'all',
    name: `${G.getWindowLocale('titles:all', 'All')} (${getFleetsLength(props)})`,
  },
  {
    width: 80,
    value: 'drivers',
    name: `${G.getWindowLocale('titles:drivers', 'Drivers')} (${getFleetsCount(props.drivers)})`,
  },
  {
    width: 80,
    value: 'trucks',
    name: `${G.getWindowLocale('titles:trucks', 'Trucks')} (${getFleetsCount(props.trucks)})`,
  },
  {
    width: 80,
    value: 'trailers',
    name: `${G.getWindowLocale('titles:trailers', 'trailers')} (${getFleetsCount(props.trailers)})`,
  },
];

export const mapFleets = (fleets) => {
  const grouped = {};
  R.forEach((item) => {
    let lnl = R.pathOr({}, ['precedingLocation'], item);
    if (G.isNilOrEmpty(lnl)) {
      lnl = R.pathOr({}, ['currentLocation'], item);
    }
    if (G.isNilOrEmpty(lnl)) return;
    const lat = R.prop(GC.FIELD_LATITUDE, lnl);
    const lng = R.prop(GC.FIELD_LONGITUDE, lnl);
    const resultItem = {
      lnl,
      fleetObj: item,
      latLng: { lat, lng },
      shortid: G.genShortId(),
    };
    let exist = false;
    R.forEachObjIndexed((value, key) => {
      const item = R.find(R.propEq(resultItem.latLng, 'latLng'), value);
      if (G.isNotNil(item)) {
        exist = true;
        grouped[key].push(resultItem);
      }
    }, grouped);
    if (G.isFalse(exist)) {
      grouped[G.genShortId()] = R.of(Array, resultItem);
    }
  }, fleets);
  return grouped;
};

export const groupFleetsByLatLng = (fleets) => {
  if (R.isNil(fleets)) return null;
  return R.values(mapFleets(fleets));
};

export const fleetTypeObjectMap = {
  all: 'all',
  trucks: 'trucks',
  drivers: 'drivers',
  trailers: 'trailers',
};
